/* tslint:disable:no-empty */

import { Injectable, EventEmitter } from "@angular/core";
import * as toastr from "toastr";

export enum ConnectionState {
  Connecting = 0,
  Connected = 1,
  Reconnecting = 2,
  Disconnected = 4,
}

@Injectable()
export class SignalRService {
  private proxy: SignalR.Hub.Proxy;
  private proxyName = "AdministrationHub";
  private connection: SignalR.Hub.Connection;
  private connected: Promise<any>;
  public connectionChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {
    this.connection = jQuery.hubConnection();

    // this.connection.logging = true;
    this.proxy = this.connection.createHubProxy(this.proxyName);

    // register dummy on (need at least one subscription before connection initialized)
    this.registerOnServerEvents();

    this.connection.stateChanged((state: any) => {
      switch (state.newState) {
        case ConnectionState.Connecting:
          //toastr.info("Establishing near real-time connection to ProManual Administration.");
          break;

        case ConnectionState.Connected:
          //toastr.success("Near real-time connection to ProManual Administration established.");
          //this.connected = undefined;
          break;

        case ConnectionState.Reconnecting:
          //toastr.info("Attempting to re-establish connection to ProManual Administration.");
          break;

        default:
          toastr.error("Cannot connect to ProManual Administration.");
          break;
      }

      this.connectionChange.emit(state.newState === ConnectionState.Connected);
    });
  }

  public isConnected(): boolean {
    return this.connection.state === ConnectionState.Connected;
  }

  public invoke(methodName: string, ...args: any[]): Promise<any> {
    if (this.isConnected()) {
      return Promise.resolve(this.proxy.invoke(methodName, ...args));
    } else {
      return Promise.resolve(
        this.startConnection().then((connected: boolean) => {
          if (connected) {
            return this.proxy.invoke(methodName, ...args);
          }
        })
      ).catch((error: any) => {});
    }
  }

  private startConnection(): Promise<boolean> {
    if (!this.isConnected()) {
      if (typeof this.connected === "undefined") {
        this.connected = Promise.resolve(
          this.connection
            .start({
              transport: [
                "webSockets",
                "serverSentEvents",
                "foreverFrame",
                "longPolling",
              ],
            })
            .done((data: any) => {
              return true;
            })
            .fail((error: any) => {
              return false;
            })
            .then((connection: any) => {
              return connection.state === ConnectionState.Connected;
            })
        );
      }
      return this.connected;
    }

    return Promise.resolve(false);
  }

  public on(eventName: string, callback: (...msg: any[]) => void): void {
    this.proxy.on(eventName, callback);
  }

  public off(eventName: string, callback: (...msg: any[]) => void): void {
    this.proxy.off(eventName, callback);
  }

  private registerOnServerEvents(): void {
    this.proxy.on("", () => {});
  }

  public deregisterOnServerEvents(): void {
    this.proxy.off("", () => {});
  }
}
